import { render } from "./Tier.vue?vue&type=template&id=f9cef53a&scoped=true"
import script from "./Tier.vue?vue&type=script&lang=js"
export * from "./Tier.vue?vue&type=script&lang=js"

import "./Tier.vue?vue&type=style&index=0&id=f9cef53a&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9cef53a"]])

export default __exports__